/**
 * @file
 * Topic list grid script.
 */

(function topicListGridScript($, Drupal) {
  'use strict';

  Drupal.behaviors.topicListGrid = {
    attach: function topicListGridAttach(context) {

      // Check for user sessionStorage.
      let userSessionData = sessionStorage.getItem('pin_pinterest_authusers.user') ? JSON.parse(sessionStorage.getItem('pin_pinterest_authusers.user')) : null;
      let facetChosen = sessionStorage.getItem('facetChosen') ? sessionStorage.getItem('facetChosen') : null;

      if (userSessionData) {
        window.userType = userSessionData.is_partner ? 'business' : 'personal';
      }

      let facetToSet = 'personal';

      if (facetChosen) {
        facetToSet = facetChosen;
      }
      else if (window.contentFacet) {
        facetToSet = window.contentFacet;
      }
      else if (window.userType) {
        facetToSet = window.userType;
      }

      let activeId = '';
      const $tabs = $('.tab__item', context);

      // Remove default active state.
      $tabs
        .attr('aria-selected', 'false')
        .removeClass('tab__item--active');

      // Change active state of tabs.
      if (facetToSet === 'business') {
        activeId = 'business';
        $('#' + activeId, context)
          .addClass('tab__item--active')
          .attr('aria-selected', 'true');
      }
      else {
        activeId = 'general';
        $('#' + activeId, context)
          .addClass('tab__item--active')
          .attr('aria-selected', 'true');
      }
      // Show the content for the selected tab.
      $('#panel-' + activeId, context).fadeIn();

      $('.tab__item', context)
        .hammer()
        .on('tap press click', function (e) {
          e.preventDefault();
          const $this = $(this);
          const thisId = $this.attr('id');
          var dataLayer = window.dataLayer = window.dataLayer || [];

          if (drupalSettings.pin_analytics && drupalSettings.pin_analytics.topicListGrid && window.ga && window.ga.loaded) {
            // GA tracking of tab clicks
            window.ga('send', {
              hitType: 'event',
              eventCategory: 'topic type',
              eventAction: 'switch',
              eventLabel: 'homepage'
            });
            // GA4 tracking of tab clicks
            dataLayer.push({
              event: 'context_switch',
              page_context: activeId
            });
          }

          let selectedFacet = thisId === 'business' ? 'business' : 'personal';
          sessionStorage.setItem('facetChosen', selectedFacet);

          let targetToSet = thisId === 'business' ? 2 : 1;
          const $menuItems = $('.menu__item', context);
          const $menuLink = $('.menu__item[data-submenu-target="' + targetToSet + '"]', context);
          const ballpitLayout = $('.tip-grid__layout', context);

          $menuItems.attr('aria-selected', 'false').removeClass('activeFacet');
          $menuLink.addClass('activeFacet').attr('aria-selected', 'true');

          if (!$this.hasClass('tab__item--active')) {
            $('.tab__item--active', context).removeClass('tab__item--active');
            $this.addClass('tab__item--active');
            $('.topic-list-grid__panel', context).hide();
            $('#panel-' + thisId, context).fadeIn();
          }

          // Switch the ballpit based on Topic List toggle.
          const ballpit = $('.tip-grid', context);
          const ballpitContext = ballpit.attr('data-context');
          if ((targetToSet === 1 && ballpitContext !== 'biz') || (targetToSet === 2 && ballpitContext !== 'general')) {
            ballpit
              .attr('aria-hidden', 'false')
              .fadeIn();
            // Update Ballpit Masonry layout.
            ballpitLayout.masonry('layout');
          }
          else {
            ballpit
              .attr('aria-hidden', 'true')
              .fadeOut();
          }

          // Switch the discover card group based on Topic List toggle.
          const discoverCardGroups = $('.discover-card-group', context);
          $.each(discoverCardGroups, function (index, element) {
            const discoverCardGroupContext = $(element).attr('data-context');
            if ((targetToSet === 1 && discoverCardGroupContext !== 'biz') || (targetToSet === 2 && discoverCardGroupContext !== 'general')) {
              $(element)
                .attr('aria-hidden', 'false')
                .fadeIn();
            }
            else {
              $(element)
                .attr('aria-hidden', 'true')
                .fadeOut();
            }
          });
        });
    }
  };
}(jQuery, Drupal));
